module.exports = __webpack_public_path__ + "img/icon-blogroll-title.255f32a2.png";